<template>
  <v-container fluid  py-0 px-0>
    <u-i-toolbar-admin title="Pending orders" icon="as fa-file-alt" />
  </v-container>
</template>

<script>

import UIToolbarAdmin from '@/components/UI/ToolbarAdmin';

export default {
  name: 'PendingOrders',
  metaInfo: {
    titleTemplate: '%s - Admin | Pending orders',
  },
  components: {
    UIToolbarAdmin,
  },
  data() {
    return {
    }
  },
  created() {

  },
  methods: {

  }
}
</script>